const WebFont = require('webfontloader');

WebFont.load({
    google: {
        families: ['Montserrat', 'Montserrat:700']
    }
});


// WEBPACK FOOTER //
// ./js/modules/webfont.js